import React from 'react'

const AutomationOptionsMusic = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="53" viewBox="0 0 50 53" fill="none" className={className}>
    <path
      d="M14.1219 52.146C16.9494 52.109 19.2182 50.3017 19.1895 48.1093C19.1608 45.9169 16.8454 44.1696 14.018 44.2067C11.1905 44.2437 8.9217 46.051 8.9504 48.2433C8.9791 50.4357 11.2945 52.183 14.1219 52.146Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M19.1807 48.1L18.9707 31.49" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path
      d="M11.704 21.45C11.897 19.2659 9.77006 17.2936 6.95334 17.0447C4.13662 16.7958 1.69676 18.3645 1.50376 20.5486C1.31075 22.7327 3.4377 24.705 6.25442 24.9539C9.07114 25.2028 11.511 23.634 11.704 21.45Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M29.954 23.0625C30.147 20.8784 28.0201 18.9061 25.2033 18.6572C22.3866 18.4083 19.9468 19.9771 19.7538 22.1611C19.5608 24.3452 21.6877 26.3175 24.5044 26.5664C27.3211 26.8153 29.761 25.2466 29.954 23.0625Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M11.6992 21.45L12.9192 7.65002" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M29.9492 23.06L31.1692 9.26001" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path
      d="M31.7118 3.10615L13.4629 1.49353L12.9198 7.63958L31.1687 9.2522L31.7118 3.10615Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M41.2503 43.3151C43.9923 42.6243 45.7809 40.3408 45.2453 38.2146C44.7097 36.0885 42.0526 34.9249 39.3106 35.6157C36.5686 36.3065 34.7799 38.59 35.3155 40.7162C35.8512 42.8423 38.5082 44.0059 41.2503 43.3151Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M45.2296 38.21L41.8496 24.78" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path
      d="M47.1258 17.0769L40.3379 18.787L41.8452 24.77L48.6331 23.06L47.1258 17.0769Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export default AutomationOptionsMusic
